import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Admin Guard
 * Restricts access to admin-only routes
 * Uses AuthService.isAdmin() for consistent admin checking
 */
export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check if user is authenticated
  if (!authService.isAuthenticated()) {
    router.navigate(['/']);
    return false;
  }

  // Check if token is expired
  if (authService.isTokenExpired()) {
    authService.logout();
    router.navigate(['/']);
    return false;
  }

  // Check if user is admin
  if (authService.isAdmin()) {
    return true;
  }

  // An admin-only group session that the API does not count as admin has no page left to show;
  // sending it home would only bring it back here (authGuard), so end the session instead.
  if (authService.ssoAdminOnly()) {
    void authService.logout();
    return false;
  }

  // User is not admin, redirect to home
  router.navigate(['/home']);
  return false;
};
